module.exports = __webpack_public_path__ + "static/media/Acen-icon.df585fd1.png";